/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiAssignmentUser } from './ApiAssignmentUser';
import {
    ApiAssignmentUserFromJSON,
    ApiAssignmentUserFromJSONTyped,
    ApiAssignmentUserToJSON,
    ApiAssignmentUserToJSONTyped,
} from './ApiAssignmentUser';
import type { ApiPerson } from './ApiPerson';
import {
    ApiPersonFromJSON,
    ApiPersonFromJSONTyped,
    ApiPersonToJSON,
    ApiPersonToJSONTyped,
} from './ApiPerson';
import type { ApiAlertStatusEvent } from './ApiAlertStatusEvent';
import {
    ApiAlertStatusEventFromJSON,
    ApiAlertStatusEventFromJSONTyped,
    ApiAlertStatusEventToJSON,
    ApiAlertStatusEventToJSONTyped,
} from './ApiAlertStatusEvent';
import type { ApiNote } from './ApiNote';
import {
    ApiNoteFromJSON,
    ApiNoteFromJSONTyped,
    ApiNoteToJSON,
    ApiNoteToJSONTyped,
} from './ApiNote';
import type { ApiAlertAssignment } from './ApiAlertAssignment';
import {
    ApiAlertAssignmentFromJSON,
    ApiAlertAssignmentFromJSONTyped,
    ApiAlertAssignmentToJSON,
    ApiAlertAssignmentToJSONTyped,
} from './ApiAlertAssignment';
import type { ApiTransaction } from './ApiTransaction';
import {
    ApiTransactionFromJSON,
    ApiTransactionFromJSONTyped,
    ApiTransactionToJSON,
    ApiTransactionToJSONTyped,
} from './ApiTransaction';

/**
 * a Bridge Alert
 * @export
 * @interface ApiBridgeAlert
 */
export interface ApiBridgeAlert {
    /**
     * 
     * @type {number}
     * @memberof ApiBridgeAlert
     */
    id: number;
    /**
     * 
     * @type {ApiAssignmentUser}
     * @memberof ApiBridgeAlert
     */
    assignee?: ApiAssignmentUser;
    /**
     * 
     * @type {Date}
     * @memberof ApiBridgeAlert
     */
    createdTime: Date;
    /**
     * 
     * @type {Array<ApiAlertAssignment>}
     * @memberof ApiBridgeAlert
     */
    assignments?: Array<ApiAlertAssignment>;
    /**
     * 
     * @type {ApiTransaction}
     * @memberof ApiBridgeAlert
     */
    transaction?: ApiTransaction;
    /**
     * 
     * @type {ApiPerson}
     * @memberof ApiBridgeAlert
     */
    person?: ApiPerson;
    /**
     * 
     * @type {string}
     * @memberof ApiBridgeAlert
     */
    status: string;
    /**
     * 
     * @type {number}
     * @memberof ApiBridgeAlert
     */
    statusId: number;
    /**
     * 
     * @type {Array<ApiAlertStatusEvent>}
     * @memberof ApiBridgeAlert
     */
    statuses?: Array<ApiAlertStatusEvent>;
    /**
     * 
     * @type {Array<ApiNote>}
     * @memberof ApiBridgeAlert
     */
    notes?: Array<ApiNote>;
    /**
     * 
     * @type {Array<ApiPerson>}
     * @memberof ApiBridgeAlert
     */
    personMatches?: Array<ApiPerson>;
    /**
     * 
     * @type {Array<ApiTransaction>}
     * @memberof ApiBridgeAlert
     */
    transactionMatches?: Array<ApiTransaction>;
}

/**
 * Check if a given object implements the ApiBridgeAlert interface.
 */
export function instanceOfApiBridgeAlert(value: object): value is ApiBridgeAlert {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('createdTime' in value) || value['createdTime'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('statusId' in value) || value['statusId'] === undefined) return false;
    return true;
}

export function ApiBridgeAlertFromJSON(json: any): ApiBridgeAlert {
    return ApiBridgeAlertFromJSONTyped(json, false);
}

export function ApiBridgeAlertFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiBridgeAlert {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'assignee': json['assignee'] == null ? undefined : ApiAssignmentUserFromJSON(json['assignee']),
        'createdTime': (new Date(json['createdTime'])),
        'assignments': json['assignments'] == null ? undefined : ((json['assignments'] as Array<any>).map(ApiAlertAssignmentFromJSON)),
        'transaction': json['transaction'] == null ? undefined : ApiTransactionFromJSON(json['transaction']),
        'person': json['person'] == null ? undefined : ApiPersonFromJSON(json['person']),
        'status': json['status'],
        'statusId': json['statusId'],
        'statuses': json['statuses'] == null ? undefined : ((json['statuses'] as Array<any>).map(ApiAlertStatusEventFromJSON)),
        'notes': json['notes'] == null ? undefined : ((json['notes'] as Array<any>).map(ApiNoteFromJSON)),
        'personMatches': json['personMatches'] == null ? undefined : ((json['personMatches'] as Array<any>).map(ApiPersonFromJSON)),
        'transactionMatches': json['transactionMatches'] == null ? undefined : ((json['transactionMatches'] as Array<any>).map(ApiTransactionFromJSON)),
    };
}

export function ApiBridgeAlertToJSON(json: any): ApiBridgeAlert {
    return ApiBridgeAlertToJSONTyped(json, false);
}

export function ApiBridgeAlertToJSONTyped(value?: ApiBridgeAlert | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'assignee': ApiAssignmentUserToJSON(value['assignee']),
        'createdTime': value['createdTime'].toISOString(),
        'assignments': value['assignments'] == null ? undefined : ((value['assignments'] as Array<any>).map(ApiAlertAssignmentToJSON)),
        'transaction': ApiTransactionToJSON(value['transaction']),
        'person': ApiPersonToJSON(value['person']),
        'status': value['status'],
        'statusId': value['statusId'],
        'statuses': value['statuses'] == null ? undefined : ((value['statuses'] as Array<any>).map(ApiAlertStatusEventToJSON)),
        'notes': value['notes'] == null ? undefined : ((value['notes'] as Array<any>).map(ApiNoteToJSON)),
        'personMatches': value['personMatches'] == null ? undefined : ((value['personMatches'] as Array<any>).map(ApiPersonToJSON)),
        'transactionMatches': value['transactionMatches'] == null ? undefined : ((value['transactionMatches'] as Array<any>).map(ApiTransactionToJSON)),
    };
}

